<template>
  <div>
    <topbar />
    <div class="wrapper-list gb-wrapper">
      <div class="wrapper-in">
        <header1 />
        <div class="content">
          <commonSidebar />
          <mainContentList />
        </div>
        <commonFooter />
      </div>
      <vueToTop />
    </div>
  </div>
</template>
<script>
import '../assets/css/list.css'
import topbar from '../components/common/topbar'
import header1 from '../components/common/header1'
import commonSidebar from '../components/common/side'
import mainContentList from '../components/news/main'
import commonFooter from '../components/common/footer'
import vueToTop from 'vue-totop'
export default {
  // mounted: function () {
  //   console.log(this.type)
  // },

  components: { topbar, header1, commonFooter, commonSidebar, mainContentList, vueToTop }
}
</script>



// WEBPACK FOOTER //
// src/views/newslist.vue